// Mobile sign-in screen — minimal login for mobile devices

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Minimal mobile sign-in screen with logo, tagline, and sign-in button.
 * @fires login
 */
class MobileSignIn extends BaseComponent {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      height: 100%;
    }

    .sign-in-screen {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      padding: 2rem 1.5rem;
      background: center center / cover no-repeat;
      position: relative;
    }

    .sign-in-screen::before {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      pointer-events: none;
    }

    .content {
      z-index: 1;
      text-align: center;
    }

    .game-title {
      font-family: 'MedievalSharp', Georgia, serif;
      font-size: 3rem;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 0.25rem 0;
      letter-spacing: 0.15em;
      text-shadow:
        0 0 8px rgba(0, 0, 0, 1),
        0 0 20px rgba(0, 0, 0, 0.9),
        0 0 40px rgba(0, 0, 0, 0.7),
        0 2px 4px rgba(0, 0, 0, 1);
    }

    .tagline {
      font-size: 0.85rem;
      color: rgba(255, 255, 255, 0.85);
      margin: 0 0 3rem 0;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      font-weight: 300;
      text-shadow:
        0 0 6px rgba(0, 0, 0, 1),
        0 0 16px rgba(0, 0, 0, 0.8);
    }

    .sign-in-btn {
      display: block;
      width: 240px;
      margin: 0 auto;
      padding: 0.85rem 1.5rem;
      font-size: 1.1rem;
      font-family: 'MedievalSharp', Georgia, serif;
      letter-spacing: 0.12em;
      color: rgba(255, 255, 255, 0.9);
      background: rgba(0, 0, 0, 0.55);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      cursor: pointer;
      text-align: center;
      backdrop-filter: blur(4px);
      -webkit-tap-highlight-color: transparent;
    }

    .sign-in-btn:active {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(0.98);
    }

    .testing-note {
      margin-bottom: 1.5rem;
    }
  `;

  _handleLogin() {
    this.dispatchEvent(new CustomEvent('login', { bubbles: true }));
  }

  render() {
    return html`
      <div
        class="sign-in-screen"
        style="background-image: url('${process.env.PUBLIC_CDN_BASE_URL}/title-screen/adventurers-at-the-barrow')"
      >
        <div class="content">
          <h1 class="game-title">RPGish</h1>
          <p class="tagline">Automated GM-Less 5e Adventures</p>
          <div class="testing-note">
            <div class="alert alert-info mb-0" style="font-size: 0.85rem;">
              <i class="bi bi-info-circle me-2"></i>RPGish is currently in closed testing.<br/>Sign in if you have been invited to test.
            </div>
          </div>
          <button class="sign-in-btn" @click="${this._handleLogin}">Sign In</button>
        </div>
      </div>
    `;
  }
}

customElements.define('mobile-sign-in', MobileSignIn);
